import React from "react";
import { Button } from "@/components/ui/button";

export function ThankYou({
  lead,
  onClose,
}: {
  lead: any;
  onClose: () => void;
}) {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-2xl bg-card shadow-[var(--shadow-elegant)]">
          <div className="grid md:grid-cols-2">
            <div className="p-8">
              <h3 className="text-lg font-semibold">Ihre Angaben</h3>
              <div className="mt-4 space-y-3 text-sm text-foreground/90">
                <div>
                  <div className="text-xs text-muted-foreground">Name</div>
                  <div className="mt-1 font-medium">{lead?.fullName || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">E‑Mail</div>
                  <div className="mt-1 font-medium">{lead?.email || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Telefon</div>
                  <div className="mt-1 font-medium">{lead?.phone || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Art des Betrugs</div>
                  <div className="mt-1 font-medium">{lead?.betrugsart || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Betrag (ungefähr)</div>
                  <div className="mt-1 font-medium">{lead?.damageAmount || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Nachricht</div>
                  <div className="mt-1 whitespace-pre-wrap">{lead?.message || "-"}</div>
                </div>
              </div>
            </div>
            <div className="p-8 border-l border-border bg-navy text-primary-foreground flex flex-col items-start justify-center">
              <h2 className="text-3xl font-bold">Vielen Dank!</h2>
              <p className="mt-3 text-white/85">Wir haben Ihre Anfrage erhalten und melden uns zeitnah per E‑Mail oder Telefon.</p>
              <p className="mt-4 text-sm text-white/70">Wenn Sie zusätzliche Unterlagen haben, antworten Sie bitte auf unsere Bestätigungsmail.</p>
              <div className="mt-6">
                <Button variant="ghost" onClick={onClose}>Zurück zur Startseite</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThankYou;
